import { render, staticRenderFns } from "./pafter.vue?vue&type=template&id=2054f89d&scoped=true&"
import script from "./pafter.vue?vue&type=script&lang=js&"
export * from "./pafter.vue?vue&type=script&lang=js&"
import style0 from "./pafter.vue?vue&type=style&index=0&id=2054f89d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2054f89d",
  null
  
)

export default component.exports